<template>
  <div class="sm-notification-top reminders">
    <div class="sm-wrap">
      <div
        class="sm-notification-top__reminders"
        @click="$router.push('/admin/mail?tab=group')"
        @mouseover="startAnimation"
        @mouseleave="stopAnimation"
      >
        <lottie
          :options="options"
          :width="50"
          :height="50"
          @animCreated="saveAnimation"
        />
        <span>You scheduled to ship mail in bulk today.</span>
        <a 
          href="#" 
          class="sm-txt-strong"
          @click.prevent
        >Go to Bulk Shipping</a>
      </div>
    </div>
  </div>
</template>

<script>
import Lottie from 'vue-lottie';
import BellAnimationData from '@/assets/json/bell-black.json';

export default {
  name: 'reminders-notification',
  components: {
    'lottie': Lottie,
  },
  data() {
    return {
      options: {
        animationData: BellAnimationData,
        autoplay: false,
        loop: false
      },
      animationItem: null,
    }
  },
  methods: {
    saveAnimation(item) {
      this.animationItem = item;
    },
    startAnimation() {
      if (this.animationItem) {
        this.animationItem.loop = true;
        this.animationItem.play();
      }
    },
    stopAnimation() {
      if (this.animationItem)
        this.animationItem.loop = false;
    },
  }
}
</script>